import { saveEditorState } from '~core';
import { editorConfig } from '~config';
import { getState, modifyState } from '~src/state';

export const startAutoSaveTimer = () => {
  const settings = getState('settings');
  const autoSaveInterval =
    settings?.autoSaveInterval || editorConfig.autoSaveInterval;

  const autoSaveTimer = setInterval(async () => {
    const totalChangesSinceLastSave = getState('totalChangesSinceLastSave');
    if (totalChangesSinceLastSave > 1) {
      await saveEditorState(true, false);
    }
  }, autoSaveInterval);

  modifyState('autoSaveTimer', autoSaveTimer);
};
